document.addEventListener("DOMContentLoaded", (event) => {
  try {

    const container = document.querySelector(".jdgm-review-snippet-widget");

    if (container) {
      // Crear un nuevo elemento <h1>
      const heading = document.createElement("h1");
      heading.textContent = "Compradores Felices, Mira las reseñas!";

      heading.style.fontWeight = "bold";
      heading.style.fontSize = "x-large";
      heading.style.whiteSpace = "pre";
      heading.style.textWrap = 'auto';
    
      // Insertar el <h1> como el primer hijo del contenedor
      container.insertBefore(heading, container.firstChild);
    } else {
      console.error("No se encontró el elemento jdgm-review-snippet-widget.");
    }
    
    
  } catch (error) {
    console.error(error);
  }
});